module.exports = __webpack_public_path__ + "static/brennan-ong-eebbb53aea675a7144eac6cca9ebf9f0.jpeg";